import React, { ComponentType, useEffect } from "react"
import { compose } from "@reduxjs/toolkit"
import { useNavigate } from "react-router-dom"
import { FormikHelpers as FormikActions } from "formik"

import { withVerification } from "hocs/features"
import { useAppDispatch } from "redux/hooks"
import { makeSmartIdAuthentication } from "redux/features/auth/smartIdThunk"
import { showAlert } from "redux/features/notice/noticeSlice"
import { reset as resetVerification } from "redux/features/verification/verificationSlice"
import { reset as resetPolling } from "redux/features/polling/pollingSlice"

import { Content, Card } from "pages/sessions/elements"
import SmartIdForm from "components/Sessions/SmartId/Form"
import Title from "components/Sessions/Title"
import Code from "components/ui/Code"
import { smartIdCountryOptions } from "helpers/countries"
import { SMART_ID_PERSONAL_CODE } from "config"
import { ClientSmartIdFormValues } from "types"

type Props = React.HTMLAttributes<HTMLDivElement> & { code: number }

const SmartIdPage = ({ code }: Props) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const countryOptions = smartIdCountryOptions()

  const handleSubmit = (
    values: ClientSmartIdFormValues,
    actions: FormikActions<object>,
  ) => {
    const { country, personal_code } = values

    dispatch(makeSmartIdAuthentication({ country, personal_code }))
      .then(() => {
        navigate("/")
      })
      .catch((error) => {
        dispatch(showAlert({ message: error }))
        actions.setSubmitting(false)
      })
  }

  const handleCancel = () => {
    dispatch(resetVerification())
    dispatch(resetPolling())
  }

  useEffect(() => {
    handleCancel()
  }, [])

  return (
    <Content data-testid="login-smart-id-page">
      <Card elevation={0}>
        <Title back />
        {code ? (
          <Code light code={code} onCancel={handleCancel} />
        ) : (
          <SmartIdForm
            initialValues={{
              country: countryOptions[0].value,
              personal_code: SMART_ID_PERSONAL_CODE,
              terms: true,
            }}
            onSubmit={handleSubmit}
          />
        )}
      </Card>
    </Content>
  )
}

export default compose<ComponentType>(withVerification)(SmartIdPage)
